import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, ButtonToolbar, Modal, Table, Alert,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/lib/Async';
import CreatableSelect from 'react-select/lib/Creatable';
import parse from 'html-react-parser';
import DatePicker from 'react-datepicker';
import Moment from 'moment';

import SelectService from '../../../services/SelectService';
import CommonService from '../../../services/CommonService';
import global from '../../../global';

class TransactionModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    modal: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
    locUrlParam: PropTypes.string,
    action: PropTypes.string,
    salesid: PropTypes.string,
  };

  static defaultProps = {
    title: 'User',
    modal: false,
    // postValue: {},
    handleSubmit: (e) => {
      e.preventDefault();
    },
    errorMsg: '',
    locUrlParam: null,
    action: 'add',
    salesid: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      statusChange: false,
      prodIndexes: [{
        index: 0,
        quality: 0,
        unitCost: 0,
        total: 0,
      }],
      grandTotal: 0,
      accountsReceivable: 0,
      amountPaid: '',
      customers: [],
      formdata: {
        chequeDate: new Date(),
        paymentType: '',
      },
    };

    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.onChangeQuantityAndCost = this.onChangeQuantityAndCost.bind(this);
    this.onChangeBalance = this.onChangeBalance.bind(this);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    // location id
    const { locUrlParam } = props;
    const mylocation = this.userdata.location_id;
    this.locationId = locUrlParam != null ? locUrlParam : mylocation !== '' ? mylocation : 0;
  }

  componentDidMount() {
    const { salesid, action } = this.props;
    this.isLoading = true;
    this.getCustomers('');
    this.getDRnumber();

    if (action === 'edit') {
      this.getTransactionInfo(salesid);
    }
  }

  componentWillReceiveProps(newProps) {
    const { salesid } = this.props;
    const id = salesid !== newProps.salesid ? newProps.salesid : salesid;

    if (newProps.action === 'edit' && newProps.modal) {
      this.getTransactionInfo(id);
    }

    if (!newProps.errorMsg && newProps.modal) {
      this.setState({
        prodIndexes: [{
          index: 0,
          quality: 0,
          unitCost: 0,
          total: 0,
        }],
        grandTotal: 0,
        accountsReceivable: 0,
        amountPaid: '',
        formdata: {
          chequeDate: new Date(),
          paymentType: '',
        },
      });
      this.getDRnumber();
    }
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  getCustomers = async (newValue) => {
    this.isLoading = true;
    const formData = { searchFor: newValue, location_from: this.locationId };
    const options = [];

    if (this.isLoading) {
      await SelectService.listCustomerOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.customer_id,
              label: opt.customer_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }
    this.isLoading = false;
    this.setState({ customers: options });
  }

  getProducts = async (newValue) => {
    this.isLoading = true;
    const formData = { searchFor: newValue, locationId: this.locationId };
    const options = [];

    if (this.isLoading) {
      await SelectService.listStoreProductsOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              value: opt.ic_id,
              label: opt.product_name,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }
    this.isLoading = false;

    return options;
  }

  getDRnumber = async () => {
    const response = await CommonService.getRows(`transactiondr/locationid/${this.locationId}`);
    if (response) {
      document.getElementsByName('dr_number')[0].value = response;
    }
  }

  async getTransactionInfo(salesid) {
    this.isLoading = true;

    if (this.isLoading && salesid) {
      try {
        const response = await CommonService.getRows(`transactioninfo/id/${salesid}`);
        if (response) {
          const { salesinfo, products } = response;
          const prodArr = [];
          if (products) {
            products.map((opt, k) => {
              // update quantity field
              if (document.getElementsByName(`quantity[${k}]`)[0]) {
                document.getElementsByName(`quantity[${k}]`)[0].value = opt.quantity;
              }
              // update unit cost field
              if (document.getElementsByName(`unitCost[${k}]`)[0]) {
                document.getElementsByName(`unitCost[${k}]`)[0].value = opt.unit_cost;
              }

              return prodArr.push({
                index: k,
                invId: opt.ic_id,
                salesProdId: opt.sales_product_id,
                productName: opt.product_name,
                quantity: opt.quantity,
                unitCost: opt.unit_cost,
                total: opt.prod_price,
              });
            });
          }

          this.setState({
            prodIndexes: prodArr,
            formdata: {
              dr_number: salesinfo.dr_number,
              customer: salesinfo.customer_id,
              customerName: salesinfo.customer_name,
              paymentType: salesinfo.payment_type,
              chequeNum: salesinfo.cheque_number,
              chequeDate: salesinfo.cheque_date,
              accountNum: salesinfo.account_number,
              accountName: salesinfo.account_name,
              bank: salesinfo.bank,
            },
            grandTotal: salesinfo.total,
            accountsReceivable: salesinfo.balance,
            amountPaid: salesinfo.amount_paid,
          });
        }
      } catch (error) {
        console.log('Error: ', error.message);
      }
    }
    this.isLoading = false;
  }

  handleInputChange = (e, fieldType = 'customer') => {
    if (fieldType === 'customer') {
      this.getCustomers(e);
    }
  }

  addProduct = () => {
    const { prodIndexes } = this.state;
    const lastItem = prodIndexes.slice(-1)[0].index;
    prodIndexes.push({
      index: parseInt(lastItem + 1, 10),
      total: 0,
    });
    this.setState({ ...prodIndexes, prodIndexes });
  }

  removeProdItem = (e, index) => {
    e.preventDefault();
    let { prodIndexes } = this.state;
    prodIndexes = prodIndexes.filter(resp => parseInt(resp.index, 10) !== parseInt(index, 10));
    this.setState({ prodIndexes });
  }

  onChangeQuantityAndCost = (e, index = '') => {
    const { prodIndexes } = this.state;
    const ret = global.numbersonly(e);
    let quantity = 0;
    let unitcost = 0;
    let total = 0;
    let gTotal = 0;

    // replace non-numeric values to empty
    if (!ret) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
    }

    // calculate total
    if (index !== '') {
      const objIdx = prodIndexes.findIndex(x => x.index === index);
      const docQ = document.getElementsByName(`quantity[${index}]`)[0].value;
      const docUc = document.getElementsByName(`unitCost[${index}]`)[0].value;
      quantity = docQ !== '' ? docQ : 0;
      quantity = parseFloat(quantity, 10);
      unitcost = docUc !== '' ? docUc : 0;
      unitcost = parseFloat(unitcost, 10);
      total = parseFloat(quantity * unitcost, 10).toFixed(2);
      prodIndexes[objIdx].total = total;

      if (prodIndexes) {
        prodIndexes.map((item) => {
          gTotal = parseFloat(gTotal, 10) + parseFloat(item.total, 10);
          return gTotal.toFixed(2);
        });
      }
    }

    this.setState({
      prodIndexes, grandTotal: gTotal, accountsReceivable: 0, amountPaid: gTotal,
    });
  }

  onChangeBalance = (e) => {
    const { accountsReceivable, grandTotal } = this.state;
    const ret = global.numbersonly(e);
    const total = grandTotal ? parseFloat(grandTotal, 10) : 0;
    let amountpaid = parseFloat(e.target.value, 10);
    let balance = accountsReceivable;

    // replace non-numeric values to empty
    if (!ret) {
      e.target.value = e.target.value.replace(/[^0-9.]/g, '');
    }

    // update balance and amount paid
    if (amountpaid > total) {
      balance = 0;
      amountpaid = total;
    } else {
      balance = parseFloat(total, 10) - amountpaid;
    }

    amountpaid = !Number.isNaN(amountpaid) ? amountpaid : 0;
    balance = !Number.isNaN(balance) ? balance.toFixed(2) : 0;

    this.setState({ accountsReceivable: balance, amountPaid: amountpaid });
  }

  handleChange = (e, fieldName = '', prodID = '') => {
    if (fieldName === 'paymenttype') {
      let paymentType = '';
      if (e) {
        paymentType = e.target.value;
      }
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, paymentType },
      }));
    } else if (fieldName === 'customer') {
      const customer = e ? e.value : '';
      const customerName = e ? e.label : '';
      this.getCustomers('');
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, customer, customerName },
      }));
    } else if (fieldName === 'product' && prodID !== '') {
      const { prodIndexes } = this.state;
      const product = e ? e.value : '';
      const productName = e ? e.label : '';

      prodIndexes.filter((prodResp) => {
        if (prodResp.salesProdId === prodID) {
          prodResp.productName = productName;
          prodResp.salesProdId = product;
        }
        return prodResp;
      });
      this.setState({ prodIndexes });
      this.setState(prevState => ({ statusChange: !prevState.statusChange }));
    } else if (fieldName === 'tdate') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, transactionDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
      }));
    } else if (fieldName === 'date') {
      const date = new Date(e);
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, chequeDate: Moment(date).format('YYYY-MM-DD HH:mm:ss') },
      }));
    } else {
      const { name, value } = e.target;
      this.setState(prevState => ({
        formdata: { ...prevState.formdata, [name]: value },
      }));
    }
 }

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      modal, toggle, title, handleSubmit, errorMsg, action,
    } = this.props;
    const {
      prodIndexes, grandTotal, accountsReceivable, customers, amountPaid, formdata,
    } = this.state;
    const totalAr = accountsReceivable === 0 ? 0 : global.parseToNumber(accountsReceivable);

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header modal-lg"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title}</h4>
          </div>
          <form id="store_transaction_form" onSubmit={handleSubmit}>
            <div className="modal__body">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <div className="alert__content">
                      <div>{ parse(errorMsg) }</div>
                    </div>
                  </Alert>
                </div>
                )
              }
              <br />
              <div className="form form--horizontal">
                <div className="form__form-group">
                    <span className="form__form-group-label">Transaction Date <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                      <div className="date-picker">
                        <DatePicker
                          name="transactionDate"
                          selected={formdata.transactionDate ? new Date(formdata.transactionDate) : new Date()}
                          onChange={e => this.handleChange(e, 'tdate')}
                        />
                      </div>
                    </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">DR # <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="dr_number" onChange={e => this.handleChange(e, 'dr_number')} placeholder="DR number" value={formdata.dr_number ? formdata.dr_number : ''} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Customer <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    {/* <input type="text" name="customer" placeholder="Customer" /> */}
                    <CreatableSelect
                      name="customer"
                      options={customers}
                      isClearable
                      className="react-select"
                      classNamePrefix="react-select"
                      placeholder="Select customer.."
                      value={
                        formdata.customerName && formdata.customer ? {
                        label: formdata.customerName ? formdata.customerName : '',
                        value: formdata.customer ? formdata.customer : '',
                      } : ''}
                      onChange={e => this.handleChange(e, 'customer')}
                      onInputChange={e => this.handleInputChange(e, 'customer')}
                    />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Payment Type <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <select name="paymentType" value={formdata.paymentType ? formdata.paymentType : ''} onChange={e => this.handleChange(e, 'paymenttype')}>
                      <option value="">-- Select --</option>
                      {
                        Object.keys(global.paymentType).map(k => (
                        <option key={k} value={k}>{global.paymentType[k]}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>
                {
                  formdata.paymentType && formdata.paymentType === '1' && (
                    <>
                    <div className="form__form-group">
                        <strong className="form__form-group-label text-primary"><u>Cheque Details</u></strong>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Bank <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="bank" defaultValue={formdata.bank ? formdata.bank : ''} placeholder="Bank" />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Cheque No. <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="chequeNum" defaultValue={formdata.chequeNum ? formdata.chequeNum : ''} placeholder="Cheque No." />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Cheque Date <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <div className="date-picker">
                            <DatePicker
                              name="chequeDate"
                              selected={formdata.chequeDate ? new Date(formdata.chequeDate) : new Date()}
                              onChange={e => this.handleChange(e, 'date')}
                            />
                          </div>
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Account No. <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="accountNum" defaultValue={formdata.accountNum ? formdata.accountNum : ''} placeholder="Account No." />
                        </div>
                    </div>
                    <div className="form__form-group">
                        <span className="form__form-group-label">Account Name <b className="text-danger">*</b></span>
                        <div className="form__form-group-field">
                          <input type="text" name="accountName" defaultValue={formdata.accountName ? formdata.accountName : ''} placeholder="Account Name" />
                        </div>
                    </div>
                    </>
                  )
                }
                <Table className="no_hover transaction_board" id="product_table">
                  <thead>
                    <tr>
                      <th width="30%">Product <b className="text-danger">*</b></th>
                      <th width="20%">Quantity <b className="text-danger">*</b></th>
                      <th width="20%">Unit Cost <b className="text-danger">*</b></th>
                      <th width="20%">Total <b className="text-danger">*</b></th>
                      <th><></></th>
                    </tr>
                  </thead>
                  <tbody>
                    {prodIndexes && prodIndexes.map((item) => {
                      const trkey = `tr_row${item.index}`;
                      const itemTotal = item.total === 0 ? 0 : global.parseToNumber(item.total);

                      return (
                        <tr key={trkey}>
                          <td data-tx="Product" className="v-top">
                            {
                              action === 'edit' && item.salesProdId ? (
                                <>
                                  <input type="hidden" name="salesProdId" defaultValue={item.salesProdId ? item.salesProdId : ''} />
                                  <AsyncSelect
                                    name={`product[${item.index}]`}
                                    value={
                                      item.productName && item.salesProdId ? {
                                      label: item.productName ? item.productName : '',
                                      value: item.salesProdId ? item.salesProdId : '',
                                    } : ''}
                                    loadOptions={this.getProducts}
                                    defaultOptions
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Select Product"
                                    onChange={e => this.handleChange(e, 'product', item.salesProdId ? item.salesProdId : '')}
                                  />
                                </>
                              ) : (
                                <AsyncSelect
                                  name={`product[${item.index}]`}
                                  loadOptions={this.getProducts}
                                  defaultOptions
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  placeholder="Select Product"
                                />
                              )
                            }
                          </td>
                          <td data-tx="Quantity">
                            <input type="text" name={`quantity[${item.index}]`} placeholder="Quantity" onChange={e => this.onChangeQuantityAndCost(e, item.index)} defaultValue={item.quantity ? item.quantity : ''} />
                          </td>
                          <td data-tx="Unit Cost">
                            <input type="text" name={`unitCost[${item.index}]`} placeholder="Unit Cost" onChange={e => this.onChangeQuantityAndCost(e, item.index)} defaultValue={item.unitCost ? item.unitCost : ''} />
                          </td>
                          <td className="td_total" data-tx="Total"><span className="m-r-3">&#x20B1;</span> {global.numberFormat(itemTotal)}</td>
                          <td className="le-td">
                            {
                              item.index !== 0 && (
                                <Button type="button" className="rounded btn-xs le-btn" onClick={e => this.removeProdItem(e, item.index)}><i className="fa fa-times" /> <span>Remove Product</span></Button>
                              )
                            }
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <div id="add_product_btn" className="text-right col-md-12">
                  <Button onClick={this.addProduct} color="success" className="rounded m-b-10" size="sm"><i className="fa fa-plus-circle" />&nbsp; Add Product</Button>
                </div>

                <Table className="no_hover m-t-0 transaction_total">
                  <tbody>
                    <tr>
                      <td className="bold">Total</td>
                      <td className="text-right text-primary" width="40px">&#x20B1;</td>
                      <td className="text-primary n">
                        {global.numberFormat(grandTotal)}
                      </td>
                    </tr>
                    <tr>
                      <td className="bold">Amount Paid</td>
                      <td className="text-right" width="40px">&#x20B1;</td>
                      <td className="n">
                        <input type="text" name="amountPaid" placeholder="Amount Paid" value={amountPaid >= 0 ? amountPaid.toString() : ''} onChange={this.onChangeBalance} />
                      </td>
                    </tr>
                    <tr>
                      <td className="bold">Balance</td>
                      <td className="text-right text-danger" width="40px">&#x20B1;</td>
                      <td className="bold text-danger n">{global.numberFormat(totalAr)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="primary">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'transaction_form', // a unique identifier for this form
})(withTranslation('common')(TransactionModal));
